module.exports = __webpack_public_path__ + "img/crema y ovulos vaginales.16fb6620.png";